<div class="login-container">
  <img alt="Logo" class="login-container__logo" src="./assets/img/brand/{{brand}}/logo_big.png">
  <span *ngIf="isTrainingEnv" class="env-display-name-banner">{{'global.testEnvInfoName' | translate}}</span>
  <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="login-container__form">
    <input [class.is-invalid]="submitted && f.username.errors" class="login-container__form__input"
           formControlName="username" placeholder="{{'login.username' | translate}}"
           type="text">
    <p *ngIf="f.username.errors && submitted" class="is-invalid--text"> {{'login.loginRequired' | translate}}</p>
    <div class="password-wrapper">
      <input [class.is-invalid]="submitted && f.password.errors" class="login-container__form__input"
             formControlName="password" placeholder="{{'login.password' | translate}}"
             [type]="showPassword ? 'text' : 'password'">
      <button type="button" class="password-toggle" (click)="showPassword = !showPassword" tabindex="-1">
        <i class="material-icons">{{showPassword ? 'visibility_off' : 'visibility'}}</i>
      </button>
    </div>
    <p *ngIf="f.password.errors && submitted" class="is-invalid--text"> {{'login.passwordRequired' | translate}}</p>

    <p *ngIf="errorLogin" class="is-invalid--text">{{'login.loginFailed' | translate}}</p>
    <button class="login-container__form__submit-button" type="submit">
      <span *ngIf="!isLoading">{{'login.loginButton' | translate}}</span>
      <app-loading-panel [isLoading]="isLoading" [size]="'small'"></app-loading-panel>
    </button>

    <div>
      <input   formControlName="remindMe" type="checkbox">
      <span class="remind-me">{{'login.remindMe' | translate}}</span>
    </div>

     <div>
      <a role="none" class="password-remind" (click)="onPasswordRemind()">{{'login.cantRememberPassword' | translate}}</a>
    </div>

  </form>
</div>
